/**
 * MTO Ölçü Paneli — konumlandırma katmanı.
 *
 * Panel native `popover` ile açılıp kapanır: açma/kapama, ESC, dışarı-tıkla ve
 * odak yönetimi TARAYICIDA. Bu dosya YALNIZCA masaüstünde paneli rozetin yanına
 * çeker. Dosya yüklenmezse popover tarayıcı varsayılanıyla ekran ortasında
 * açılır — işlev kaybı yok (progressive enhancement).
 *
 * İki tuzak, ikisi de burada çözülüyor:
 *
 * 1) UA stil sayfası [popover] için `inset: 0; margin: auto` verir. Yalnız
 *    left/top yazmak ETKİSİZDİR — kutu over-constrained kalır ve `margin:auto`
 *    onu sağ kenarla ortalar. right/bottom `auto`, margin `0` da yazılmalı.
 *    Bu geri alma CSS'te DEĞİL burada: JS yoksa UA'nın ortalaması korunmalı.
 *
 * 2) `toggle` olayı ASENKRONDUR — panel biz konumlandırmadan önce bir kare
 *    ortada boyanır (görünür zıplama). Bu yüzden senkron `beforetoggle`da
 *    görünürlük kapatılır, `toggle`da konumlanıp geri açılır.
 *
 * Olaylar `document` üzerinde capture ile dinlenir (popover olayları BUBBLE
 * ETMEZ, capture fazı çalışır); böylece koleksiyon grid'i filtre değişiminde
 * Section Rendering API ile baştan basıldığında yeni paneller de çalışır.
 */
(function () {
  if (window.__mtoSizePanel) return;
  window.__mtoSizePanel = true;

  var GAP = 8;
  var desktop = window.matchMedia('(min-width: 750px)');

  function isPanel(el) {
    return el && el.hasAttribute && el.hasAttribute('data-mto-size-panel');
  }

  function badgeOf(panel) {
    var wrap = panel.closest('.mto-size');
    return wrap ? wrap.querySelector('.mto-size__badge') : null;
  }

  function reset(panel) {
    var s = panel.style;
    s.removeProperty('left');
    s.removeProperty('top');
    s.removeProperty('right');
    s.removeProperty('bottom');
    s.removeProperty('margin');
    s.removeProperty('max-height');
    s.removeProperty('visibility');
  }

  function place(panel) {
    // Mobilde alt sayfa (bottom sheet) — konum CSS'ten gelir.
    if (!desktop.matches) {
      reset(panel);
      return;
    }

    var badge = badgeOf(panel);
    if (!badge) {
      reset(panel);
      return;
    }

    var s = panel.style;

    // right/bottom/margin geri alması ZORUNLU (bkz. tuzak 1) ve ölçümden ÖNCE
    // yazılmalı — yoksa `margin:auto` ölçülen genişliği/konumu bozar.
    s.right = 'auto';
    s.bottom = 'auto';
    s.margin = '0';
    s.removeProperty('max-height');

    var b = badge.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var pw = panel.offsetWidth;
    // CSS tavanı (min(38rem, 70vh)) uygulanmış doğal yükseklik. Inline
    // max-height YALNIZCA bunu KÜÇÜLTMEK için yazılır, asla büyütmek için.
    var natural = panel.offsetHeight;

    var left = b.left;
    if (left + pw > vw - GAP) left = vw - pw - GAP;
    if (left < GAP) left = GAP;

    // Panel rozetin ALTINDA kalmayı tercih eder — mekânsal bağ korunur ve
    // ürün görselinin üstünü kapatmaz. Sığmıyorsa ÇEVİRMEK yerine KISALTILIR
    // (liste kendi içinde kaydırılabilir); kalan yer MIN_H'nin altına düşer ve
    // yukarıda daha çok yer varsa yukarı çevrilir.
    var MIN_H = 200;
    var below = vh - b.bottom - GAP * 2;
    var above = b.top - GAP * 2;
    var top;

    if (below >= MIN_H || below >= above) {
      if (below < natural) s.maxHeight = Math.max(MIN_H, below) + 'px';
      top = b.bottom + GAP;
    } else {
      if (above < natural) s.maxHeight = Math.max(MIN_H, above) + 'px';
      top = b.top - panel.offsetHeight - GAP;
    }

    s.left = left + 'px';
    s.top = Math.max(GAP, top) + 'px';
    s.removeProperty('visibility');
  }

  document.addEventListener(
    'beforetoggle',
    function (event) {
      if (!isPanel(event.target)) return;
      // Konumlanmadan boyanmasın (bkz. tuzak 2).
      if (event.newState === 'open' && desktop.matches) {
        event.target.style.visibility = 'hidden';
      }
    },
    true
  );

  document.addEventListener(
    'toggle',
    function (event) {
      var panel = event.target;
      if (!isPanel(panel)) return;

      var badge = badgeOf(panel);
      var open = event.newState === 'open';
      if (badge) badge.setAttribute('data-open', open ? 'true' : 'false');

      if (open) {
        place(panel);
      } else {
        reset(panel);
      }
    },
    true
  );

  function openPanels() {
    try {
      return document.querySelectorAll('[data-mto-size-panel]:popover-open');
    } catch (e) {
      return [];
    }
  }

  /**
   * Rozet hâlâ görünür mü? Viewport'a ek olarak kırpan ATA kutuları da sayılır —
   * slider (.mto-pl__track) yatay kaydırıldığında rozet track'in dışına çıkar
   * ama viewport içinde kalabilir. Merkez noktası testi: yarıdan fazlası
   * kaybolduğunda panel kapanır (kenar durumlarında titremeyi önler).
   */
  function badgeVisible(badge) {
    var r = badge.getBoundingClientRect();
    if (!r.width && !r.height) return false;

    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    if (cx < 0 || cx > window.innerWidth || cy < 0 || cy > window.innerHeight) return false;

    var node = badge.parentElement;
    while (node && node !== document.body) {
      var cs = getComputedStyle(node);
      var clips = /auto|scroll|hidden|clip/.test(cs.overflowX + ' ' + cs.overflowY);
      if (clips) {
        var nr = node.getBoundingClientRect();
        if (cx < nr.left || cx > nr.right || cy < nr.top || cy > nr.bottom) return false;
      }
      node = node.parentElement;
    }
    return true;
  }

  var pending = 0;
  function reflow() {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = 0;
      Array.prototype.forEach.call(openPanels(), function (panel) {
        var badge = badgeOf(panel);
        // Rozet kaydırılıp gözden kayboldu: paneli ekran kenarına yapıştırıp
        // açık tutmak kafa karıştırıcı — kapat.
        if (badge && !badgeVisible(badge)) {
          panel.hidePopover();
          return;
        }
        place(panel);
      });
    });
  }

  window.addEventListener('resize', reflow);
  desktop.addEventListener('change', reflow);

  // scroll: CAPTURE fazında document'ta. Sayfa kaydırması `window`da yeterdi ama
  // slider'ların (.mto-pl__track) YATAY kaydırması bir ELEMENT scroll'udur ve
  // bubble ETMEZ — capture olmadan panel eski konumunda kalır, rozet kayar.
  document.addEventListener('scroll', reflow, { passive: true, capture: true });
})();
